export default {
  zhHans: {
    $vuetify: {
      badge: '徽章',
      close: '关闭',
      dataIterator: {
        noResultsText: '没有符合条件的结果',
        loadingText: '加载中……',
      },
      dataTable: {
        itemsPerPageText: '每页数目：',
        ariaLabel: {
          sortDescending: '：降序排列。点击以移除排序。',
          sortAscending: '：升序排列。点击以降序排列。',
          sortNone: '：未排序。点击以升序排列。',
        },
        sortBy: '排序方式',
      },
      dataFooter: {
        itemsPerPageText: '每页数目：',
        itemsPerPageAll: '全部',
        nextPage: '下一页',
        prevPage: '上一页',
        firstPage: '首页',
        lastPage: '尾页',
        pageText: '{0}-{1} 共 {2}',
      },
      datePicker: {
        itemsSelected: '已选择 {0}',
      },
      noDataText: '没有数据',
      carousel: {
        prev: '上一张',
        next: '下一张',
        ariaLabel: {
          delimiter: 'Carousel slide {0} of {1}',
        },
      },
      calendar: {
        moreEvents: '还有 {0} 项',
      },
      fileInput: {
        counter: '{0} 个文件',
        counterSize: '{0} 个文件（共 {1}）',
      },
      timePicker: {
        am: '上午',
        pm: '下午',
      },
      custom: {
        title:"易途基础架构",

        cancelBtn:'取消',
        okBtn:'确定',
        searchBtn:'查询',
        addBtn:'添加',
        deleteBtn:'删除',
        enable:'启用',
        disable:'禁用',
        //表格
        dataLoading:'数据加载中...',
        dataNothing:'暂无数据',
        /*问询提示*/
        pleaseSelectDelete:'请选择要删除的数据',
        deleteNow:'确定要当前选中的所有数据吗?',
        deleteSelect:'确定要删除当前的数据吗?',
        /*表格列*/
        actions:'操作',
        creator:'创建人',
        createTime:'创建时间',
        editor:'修改人',
        updateTime:'修改时间',
        icon:"图标",
        image:"图片",
        preservation:"保存",
        pleaseSelectImageFile:"请选择图像文件",
        giveUpOperation:"放弃操作",
        pleaseEnery:"请输入",
        error:"错误",
        updateSuccess:"修改成功",
        tips:"提示",
        defaultContent:"默认内容",
        entryKeyWordSelect:"输入关键词回车查找",
        etBaseFramework:"易途基础框架",
        userSpaceAdd:"用户 添加",
        addSuccess:"添加成功",
        login: {
          passwordLogin: '密码登录',
          loginName: '邮箱/姓名/工号',
          password:'请输入登录密码',
          login:'登 录',
          scanLogin:'扫码登录',
          forgetPassword:'忘记密码',
          forgetUsername:'忘记用户名',
          register:'免费注册'
        },
        user: {
          work:'在职',
          notWork:'离职',
          pleaseSelect:'请选择',
          userName:'用户名',
          password:"密码",
          realName:'真实姓名',
          phone:'手机',
          email:'邮箱',
          enableItems:'启用状态',
          workItems:'在职状态',
          lastLoginTime:'最后登录时间',

        },
        menu: {
          setUpState:"设置状态",
          userInformation:"用户资料",
          setUp:"设置",
          logOUt:"退出",
          menuPreview:"菜单预览",
          menuName:"菜单名字",
          routerAddress:"路由地址",
          authorityCode:"权限编码",
          updateMenu:"修改菜单",
          deleteMenu:"删除菜单",
          addPeer:"新增同级",
          addSubset:"新增子集",
          menuOperation:"菜单操作",
          theCtNCAStPtPTAgain:"当前节点不能添加子集,请选择父级重试!",
          canYCDTCMenu:"您确定要删除当前菜单吗?",
          canYCDTCSubMenu:"您确定要删除当前菜单及子菜单吗?",
        },

      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/i18n/zhHans.js